import React from 'react';
import { Trans } from 'react-i18next';
import { MASTER_DATA, JOBS, makeJobUrl } from 'src/routes/routes';

export const makeBreadcrumbs = job => [
  {
    id: 1,
    text: <Trans>MASTER_DATA</Trans>,
    link: MASTER_DATA,
  },
  {
    id: 2,
    text: <Trans>JOBS</Trans>,
    link: JOBS,
  },
  {
    id: 3,
    text: job.reportNumber || '',
    link: makeJobUrl(job.id || 'new'),
  },
];
